import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { isExist } from 'src/utils/function';

// -------------------------------------------------------------

const initialState = {
  isOpen: false,
  isYesOrNoOpen: false,
  noMsg: '아니오',
  yesMsg: '예',
  msg: '',
  detail: '',
  outlineStyle: false,
  url: '',
  func: '',
  api: null
};

const slice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, actions) => {
      state.msg = actions.payload;
      state.isOpen = isExist(actions.payload) ? true : false;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    yesOrNoOpenModal: (state, action) => {
      state.msg = action.payload.msg;
      state.func = action.payload.func;
      state.api = action.payload.api;
      state.url = action.payload.url;
      state.noMsg = action.payload.noMsg || '아니오';
      state.yesMsg = action.payload.yesMsg || '예';
      state.outlineStyle = action.payload.outlineStyle;
      state.isYesOrNoOpen = isExist(action.payload) ? true : false;
    },
    yesOrNoCloseModal: (state) => {
      state.isYesOrNoOpen = false;
    },
    setError(state, action) {
      const msg = action.payload?.message;
      const detail = action.payload?.detail;
      state.msg = msg;
      state.detail = detail;
      state.isOpen = isExist(msg) || isExist(detail) ? true : false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openModal, setError, closeModal, yesOrNoCloseModal } = slice.actions;

// ---------------------------------------------------------
// 일반 메시지 모달

export function getOpen(msg) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.openModal(msg));
    } catch (error) {
      console.log('error', error);
    }
  };
}

// -------------------------------------------------------------

export function getOpenAlert(msg) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.openModal(msg));
    } catch (error) {
      console.log('error', error);
    }
  };
}

// -------------------------------------------------------------

export function getClose() {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.closeModal());
    } catch (error) {
      console.log('error', error);
    }
  };
}

// ---------------------------------------------------------
// 예 아니오 선택모달 오픈

export function getYesOrNoOpen(params) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.yesOrNoOpenModal(params));
    } catch (error) {
      console.log('error', error);
      dispatch(slice.actions.yesOrNoCloseModal(params));
    }
  };
}

// ---------------------------------------------------------// 예 아니오 선택모달 닫기

export function getYesOrNoClose() {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.yesOrNoCloseModal());
    } catch (error) {
      console.log('error', error);
    }
  };
}
